export enum LangEnum {
  KH = 'kh',
  EN = 'en',
}
